import { RootState } from "@/redux/store";

export const clientsSelector = (state: RootState) => state.client.clients;
export const clientsPageSelector = (state: RootState) => state.client.page;
export const clientOptionsSelector = (state: RootState) => state.client.options;
